import './style.css'

function Footer() {
  
    return (
            <section className='footer'>
                <footer>
                    <div>
                        <section>
                            <p>
                            <span>Proyecto</span> - Curso React JS - <span>Coderhouse</span>
                            </p>
                        </section>
                    </div>
                    <div>
                        © 2023 Copyright: Juan Ignacio Rago
                    </div>
                </footer>
            </section>
        )
  }

  export default Footer;